import React, { useState, useEffect } from "react";

function Gallery({ titulo, imagenes }) {
  const [indice, setIndice] = useState(0);

  // Cambia la imagen cada 4 segundos
  useEffect(() => {
    const intervalo = setInterval(() => {
      setIndice((prev) => (prev + 1) % imagenes.length);
    }, 4000);

    return () => clearInterval(intervalo);
  }, [imagenes]);

  return (
    <div className="flex flex-col items-center w-full max-w-6xl mx-auto p-4 md:p-6 rounded-2xl shadow-lg">
      {/* Título */}
      <h2 className="text-azul-oscuro text-2xl md:text-3xl font-bold text-center uppercase tracking-wide mb-4">
        {titulo}
      </h2>

      {/* Contenedor de Imagen Principal */}
      <div className="w-full max-w-4xl">
        <div className="w-full aspect-w-16 aspect-h-9">
          <img
            src={imagenes[indice]}
            alt="Imagen Principal"
            className="w-full h-full object-cover rounded-xl shadow-md transition-all duration-500 hover:scale-105"
          />
        </div>
      </div>

      {/* Miniaturas en una fila horizontal */}
      <div className="flex flex-wrap justify-center gap-2 md:gap-4 mt-4">
        {imagenes.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`Miniatura ${i + 1}`}
            className={`w-16 h-16 md:w-24 md:h-24 object-cover rounded-lg shadow-md cursor-pointer transition-all duration-300 hover:scale-110 ${
              i === indice ? "opacity-50" : ""
            }`}
            onClick={() => setIndice(i)}
          />
        ))}
      </div>
    </div>
  );
}

export default Gallery;
